import { render, staticRenderFns } from "./ImportShippingReleaseApprovement.vue?vue&type=template&id=0dfe8074"
import script from "./ImportShippingReleaseApprovement.vue?vue&type=script&lang=js"
export * from "./ImportShippingReleaseApprovement.vue?vue&type=script&lang=js"
import style0 from "./ImportShippingReleaseApprovement.vue?vue&type=style&index=0&id=0dfe8074&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports